import { useQuery } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { AuditAlertResponse } from "../../auditLog.types";
import { requestGetAuditAlertById } from "./getAuditAlertById.request";

const useGetAuditAlertById = (
  alertId: string,
  options?: QueryOptions<AuditAlertResponse, ApiServiceError<ApiError>>
) => {
  const { data: auditAlert, ...rest } = useQuery({
    queryKey: ["audit-alerts", "admin", "one", alertId],
    queryFn: async () => await requestGetAuditAlertById(alertId),
    enabled: !!alertId,
    cacheTime: 0,
    ...options
  });

  return { auditAlert, ...rest };
};

export default useGetAuditAlertById;
